module.exports = __webpack_public_path__ + "img/chezai.a07c41f0.jpg";